<template>
	<div
			id="home"
			class="home"
			:class="theme">
		<!--<nav-bar></nav-bar>-->

		<swiper :options="swiperOption" ref="mySwiper">
			<!-- slides -->
			<swiper-slide>
				<!--<div v-bind:style="{ height: bgHeight, backgroundImage: 'url(' + bgUrl+ ')', backgroundSize: bgSize, backgroundRepeat: bgRepeat}"></div>-->
				<div style="height: 100%; background-image: url('../assets/img/bg1512.jpg'); background-size: cover; background-repeat: no-repeat;">
					<div class="slide-center">
						<div>
							<!--<img src="../assets/img/bonelldoriga_wh_hg.png" alt="Bonell+Dòriga"
								 style="width: auto; height: 80vh;"/>-->
							<img :src="logoUrl" @mouseover="logoUrl = logoHighlightUrl" @mouseout="logoUrl = logoNormalUrl" @click="goTo('main')" alt="Bonell+Dòriga"
								 style="width: auto; height: 40vh;"/>

						</div>
						<!--<div class="super-title">BONELL+DORIGA</div>-->
						<!--<div class="sub-title">Bonell+Dòriga architects, Barcelona</div>-->

					</div>
				</div>
			</swiper-slide>
		</swiper>
		<!--<logo-bar></logo-bar>
		<footer-bar></footer-bar>-->
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import router from '../router'
    import { localStorageMixin } from '../mixins'
    import FooterBar from '../components/FooterBar.vue'
    import LogoBar from '../components/LogoBar.vue'
    import NavBar from '../components/NavBar.vue'
    import Field from '../components/Field.vue'
    import Message from '../components/Message.vue'
    import Preview from '../components/Preview.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    import 'swiper/dist/css/swiper.css'




    export default {
        name: 'home',

        mixins: [localStorageMixin],

        components: {
            FooterBar,
            LogoBar,
            Field,
            Message,
            NavBar,
            Preview,
            swiper,
            swiperSlide

        },

        data: () => ({
			logoUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoNormalUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoHighlightUrl: '../assets/img/bonelldoriga_wh_hg_3.png',
            fontSize: '',
            fields: {
                email: {
                    name: 'Email Address',
                    value: '',
                    type: 'text',
                    placeholder: 'monica@raviga.com',
                    autofocus: false
                },
                password: {
                    name: 'Password',
                    value: '',
                    type: 'password',
                    placeholder: 'Super, secret',
                    autofocus: false
                }
            },
            error: null,
            swiperOption: {
                centeredSlides: true,
                slidesPerView: 1
			}
        }),

        computed: {
            ...mapGetters([
                'user',
                'theme'
            ])
        },

        methods: {
            ...mapActions([
                'SIGN_UP_USER',
                'INIT_NOTES'
            ]),

            onCreateAccount () {
                if (this.fields.email.value.length == 0) {
                    this.error = 'Please enter an email realestate.'
                    return
                }

                if (this.fields.password.value.length == 0) {
                    this.error = 'Please enter a password.'
                    return
                }

                const data = {
                    email: this.fields.email.value,
                    password: this.fields.password.value
                }

                this.SIGN_UP_USER(data)
                    .then(() => {
                        this.ls_pushUser(this.user)
                        console.log()
                        this.INIT_NOTES()
                            .then(() => this.$router.push({name: 'app'}))
                            .catch((error) => this.error = error.message)
                    })
                    .catch((error) => {
                        this.error = error.message
                    })
            },

            onQuoteRequest () {
                this.$router.push({name: 'quote-request', query: {email: this.fields.email.value}})
            },

            onSignUp () {
                this.$router.push({name: 'signup', query: {email: this.fields.email.value}})
            },

            onLogIn () {
                this.$router.push({name: 'login'})
            },
            goTo (location,) {
                this.$router.push({name: location})
            },
            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Home'
            }
        }

    }
</script>

<style scoped>

	.swiper-container {
		height: 100vh;
		width: 100%;
	}

	.slide-img {
		width: 100%;
		height: auto;
	}

	.swiper-button-prev  {
		background-image: none;
		left: 0;
		width: 50vw;
		height: 100vh;
		top: 0;
	}

	.swiper-button-next {
		background-image: none;
		right: 0;
		width: 50vw;
		height: 100vh;
		top: 0;
	}

</style>


// WEBPACK FOOTER //
// Home.vue?3fb9d61e